const rupiahToNumber = (value) => {
  if (!value) return 0;
  return Number(value.replace(/[^\d]/g, ""));
};

export const transformChartL3Y = (rawData = []) => {
  const filteredData = rawData.filter(
    (item) => item.kodeCabang !== "Total"
  );

  if (!filteredData.length) {
    return { data: [], dataKey: [] };
  }

  const quarterKeys = Object.keys(filteredData[0]).filter((key) =>
    key.match(/^(y2q|y1q|yq)\d$/)
  );

  const orderQuarter = (key) =>
    key.startsWith("y2") ? 1 : key.startsWith("y1") ? 2 : 3;

  quarterKeys.sort(
    (a, b) => orderQuarter(a) - orderQuarter(b) || a.localeCompare(b)
  );

  // DATA CHART
  const data = quarterKeys.map((quarter) => {
    const row = { division: quarter };

    filteredData.forEach((item) => {
      row[item.kodeCabang] = rupiahToNumber(item[quarter]);
    });

    return row;
  });

  const dataKey = filteredData.map((item) => ({
    key: item.kodeCabang,
    color: "#1976D2", 
  }));

  return { data, dataKey };
};
